import React, { useEffect, useRef } from "react";
import { cufrontIcons } from "../../cufront-assets/icons/Icons";
import CuInput from "../components/CuInput";
import { CiImageOn } from "react-icons/ci";
import { MdOutlineClose } from "react-icons/md";
import { CiFileOn } from "react-icons/ci";
import { CiCamera } from "react-icons/ci";
import { medicalTabs } from "../../_helper/constant/constant";
import { useSearchParams } from "react-router-dom";

const UplaodReport = ({
  setReportName,
  setDescription,
  recordId,
  setRecordId,
  setSelectedDate,
  selectedFile,
  setSelectedFile,
}) => {
  const [searchParams] = useSearchParams();
  const optionTab = searchParams.get("option-tab");
  useEffect(() => {
    setRecordId(optionTab);
  }, []);

  const fileInputRef = useRef(null);
  const camerafileInputRef = useRef(null);
  const pdfInputRef = useRef(null);

  const handleFileChange = (e) => {
    const filesArray = Array.from(e.target.files);
    setSelectedFile((prev) => [...prev, ...filesArray]);
  };

  const handleCameraButtonClick = () => {
    if (camerafileInputRef.current) {
      camerafileInputRef.current.click();
    }
  };

  const handleFileButtonClick = () => {
    fileInputRef.current.click();
  };

  const handlePdfButtonClick = () => {
    if (pdfInputRef.current) {
      pdfInputRef.current.click();
    }
  };

  const handleRemoveFile = (index) => {
    setSelectedFile((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  return (
    <div className="max-h-[85vh] h-fit lg:max-h-fit">
      <div>
        <div className="mt-2 lg:mt-0">Select Report Type</div>
        <div className="flex gap-3 flex-wrap mt-2">
          {medicalTabs
            .filter((item) => item.name.toLocaleLowerCase() !== "appointments")
            .map((item, i) => {
              return (
                <div
                  className={`py-2 px-4 border-[0.5px] border-[#00000033] cursor-pointer rounded-[6px] ${
                    recordId?.toLowerCase() === item?.name?.toLowerCase()
                      ? "bg-[#C7EAC9]"
                      : ""
                  }`}
                  key={i}
                  onClick={() => setRecordId(item?.name.toLocaleLowerCase())}
                >
                  {item?.label}
                </div>
              );
            })}
        </div>
        <div className="mt-5">
          <CuInput
            label={"Report Name"}
            placeholder={"Enter Report Name"}
            onChange={(e) => setReportName(e.target.value)}
            required={true}
            star={true}
          />
        </div>
        <div className="mt-5">
          <CuInput
            label={"Report Date"}
            placeholder={"Enter Report Date"}
            onChange={(e) => setSelectedDate(e.target.value)}
            type={"date"}
          />
        </div>
        <div className="mt-5">
          <div className="mt-2 mb-1">Description</div>
          <div className="w-full h-[100px] border border-[#00000033] rounded-md">
            <textarea
              type="text"
              placeholder="Enter description"
              className="p-2 w-full h-full outline-none"
              onChange={(e) => setDescription(e.target.value)}
            ></textarea>
          </div>
        </div>
        <div className="mt-5">
          <div className="mt-2">
            Upload From {<span className="text-red-500">*</span>}
          </div>
          <div className="w-full flex gap-3 mt-2 text-center">
            <div onClick={handleCameraButtonClick} className="block lg:hidden">
              <div className="w-16 h-16 cursor-pointer border border-[#00000033] m-auto rounded-full flex justify-center items-center">
                <CiCamera size={30} color="#3f3f3f" />
              </div>
              <div>Camera</div>
              <input
                type="file"
                accept="image/*"
                capture="environment"
                multiple
                ref={camerafileInputRef}
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
            </div>

            {/* {error && <div>Error: {error.message}</div>} */}

            <div onClick={handleFileButtonClick}>
              <div className="w-16 h-16  cursor-pointer border border-[#00000033] m-auto rounded-full flex justify-center items-center">
                {/* <img className="h-8 w-8" src={cufrontIcons?.gallery} alt="Images" /> */}
                <CiImageOn size={30} color="#3f3f3f" />
              </div>
              <div>Images</div>
              <input
                ref={fileInputRef}
                type="file"
                accept="image/*"
                multiple
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
            </div>
            <div onClick={handlePdfButtonClick}>
              <div className="w-16 h-16 border  cursor-pointer border-[#00000033] m-auto rounded-full flex justify-center items-center">
                {/* <img className="h-8 w-8" src={cufrontIcons?.files} alt="Files" /> */}
                <CiFileOn size={30} color="#3f3f3f" />
              </div>
              <div>Files</div>
              <input
                ref={pdfInputRef}
                type="file"
                accept=".pdf"
                multiple
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
            </div>
          </div>
        </div>
        <>
          {selectedFile &&
            selectedFile.map((file, i) => {
              return (
                <div className="flex items-center gap-5 my-5" key={i}>
                  <div className="w-6 h-full">
                    <img
                      className="h-full w-full cursor-pointer"
                      src={
                        file.name.split(".").pop() == "pdf"
                          ? cufrontIcons.documentIcon
                          : cufrontIcons.galleryImg
                      }
                      alt=""
                    />
                  </div>
                  <div className="h-full">
                    <div>
                      {file?.name.length > 50
                        ? `${file?.name.substring(0, 50)}...`
                        : file?.name}
                    </div>
                    <div className="text-[#979797] text-[10px]">
                      {file?.size
                        ? file.size > 1024 * 1024
                          ? `${(file.size / (1024 * 1024)).toFixed(2)} MB`
                          : file.size > 1024
                          ? `${(file.size / 1024).toFixed(2)} KB`
                          : `${file.size} bytes`
                        : "File size unavailable"}
                    </div>
                  </div>
                  <span
                    className="text-red-500 cursor-pointer"
                    onClick={() => handleRemoveFile(i)}
                  >
                    <MdOutlineClose />
                  </span>
                </div>
              );
            })}
        </>
      </div>
    </div>
  );
};

export default UplaodReport;
